<template>
  <DefaultSection class="is-hidden-mobile has-border-section">
    <Container>
      <div class="level">
        <div
          v-for="item in images"
          :key="item?.mid"
          class="level-item has-text-centered"
        >
          <ImageItem
            v-bind="item?.image"
            image-style="paragraph_logos_fill-mobile"
          />
        </div>
      </div>
    </Container>
  </DefaultSection>
</template>

<script setup lang="ts">
import type { ParagraphLogosFragment } from '#graphql-operations'

defineProps<ParagraphLogosFragment>()
defineBlokkli({
  bundle: 'logos',
})
</script>

<style scoped lang="scss">
.section {
  @include tablet {
    padding: toRem(20) toRem(40);
  }

  @include widescreen {
    padding: toRem(60) toRem(40);
  }

  @include fullhd {
    padding: toRem(60) 11rem;
  }
}
</style>
